import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading skeleton dla DocsPage (lazy import suspense fallback + auth loading).
 * Layout 280px sidebar + main content.
 */
export default function DocsSkeleton() {
  return (
    <div className="flex h-full">
      <aside className="w-[280px] border-r border-border p-4 space-y-3 hidden md:block">
        <Skeleton className="h-9 w-full" />
        <div className="space-y-2 pt-4">
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} className="h-6 w-full" />
          ))}
        </div>
      </aside>
      <main className="flex-1 p-8 max-w-3xl space-y-4">
        <Skeleton className="h-10 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
        <div className="space-y-3 pt-6">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/6" />
        </div>
      </main>
    </div>
  );
}
